module.exports = __webpack_public_path__ + "img/IMG_1899_L_Wood_MockedUp.997338ec.jpg";